import React from "react";
import Alert from '../../../components/Alerts/Alert';
import { useProjectConfigContext } from "../../../contexts/ProjectConfigContext";
import TakanonCheckBox from "./form/TakanonCheckBox";
import { AlertColors } from "../../../enums/colors/alertColors.type";
import addRequestPageLang from "../../../data/lang/add-request-page.lang";
import useTags from "../../../hooks/useTags";

export default function Takanon() {

    const { projectConfigState } = useProjectConfigContext();

    let takanonMessage: string | React.ReactNode = '';
    const projectId = projectConfigState.projectId;

    const generateTag = useTags();

    const takanonTitleTag = generateTag(addRequestPageLang, 'takanon.title');

    const projectId69Title = generateTag(addRequestPageLang, 'takanon.projectId69.title');
    const projectId69Line1 = generateTag(addRequestPageLang, 'takanon.projectId69.line1');
    const projectId69Line2 = generateTag(addRequestPageLang, 'takanon.projectId69.line2');
    const projectId69Line3 = generateTag(addRequestPageLang, 'takanon.projectId69.line3');
    const projectId69Line4 = generateTag(addRequestPageLang, 'takanon.projectId69.line4');
    const projectId69Line5 = generateTag(addRequestPageLang, 'takanon.projectId69.line5');

    const projectId26Title = generateTag(addRequestPageLang, 'takanon.projectId26.title');
    const projectId26Line1 = generateTag(addRequestPageLang, 'takanon.projectId26.line1');
    const projectId26Line2 = generateTag(addRequestPageLang, 'takanon.projectId26.line2');
    const projectId26Line3 = generateTag(addRequestPageLang, 'takanon.projectId26.line3');

    const projectId25Title = generateTag(addRequestPageLang, 'takanon.projectId25.title');
    const projectId25Line1 = generateTag(addRequestPageLang, 'takanon.projectId25.line-1');
    const projectId25Line2 = generateTag(addRequestPageLang, 'takanon.projectId25.line-2');
    const projectId25Line3 = generateTag(addRequestPageLang, 'takanon.projectId25.line-3');
    const projectId25Line4 = generateTag(addRequestPageLang, 'takanon.projectId25.line-4');
    const projectId25Line5 = generateTag(addRequestPageLang, 'takanon.projectId25.line-5');
    const projectId25Line6 = generateTag(addRequestPageLang, 'takanon.projectId25.line-6');
    const projectId25Line7 = generateTag(addRequestPageLang, 'takanon.projectId25.line-7');

    const projectId94Title = generateTag(addRequestPageLang, 'takanon.projectId94.title');
    const projectId94Line1 = generateTag(addRequestPageLang, 'takanon.projectId94.line1');
    const projectId94Line2 = generateTag(addRequestPageLang, 'takanon.projectId94.line2');
    const projectId94Line3 = generateTag(addRequestPageLang, 'takanon.projectId94.line3');
    const projectId94Line4 = generateTag(addRequestPageLang, 'takanon.projectId94.line4');

    const projectId87Line1 = generateTag(addRequestPageLang, 'takanon.projectId87.line-1');
    const projectId87Line2 = generateTag(addRequestPageLang, 'takanon.projectId87.line-2');
    const projectId87Line3 = generateTag(addRequestPageLang, 'takanon.projectId87.line-3');

    const projectId12Line1 = generateTag(addRequestPageLang, 'takanon.projectId12.line-1');
    const projectId12Line2 = generateTag(addRequestPageLang, 'takanon.projectId12.line-2');
    const projectId12Line3 = generateTag(addRequestPageLang, 'takanon.projectId12.line-3');
    const projectId12Line4 = generateTag(addRequestPageLang, 'takanon.projectId12.line-4');
    const projectId12List1 = generateTag(addRequestPageLang, 'takanon.projectId12.list.item-1');
    const projectId12List2 = generateTag(addRequestPageLang, 'takanon.projectId12.list.item-2');
    const projectId12List3 = generateTag(addRequestPageLang, 'takanon.projectId12.list.item-3');
    const projectId12List4 = generateTag(addRequestPageLang, 'takanon.projectId12.list.item-4');
    const projectId12List5 = generateTag(addRequestPageLang, 'takanon.projectId12.list.item-5');
    const projectId12List6 = generateTag(addRequestPageLang, 'takanon.projectId12.list.item-6');

    const defaultTakanonLine1 = generateTag(addRequestPageLang, 'takanon.default.line-1');
    const defaultTakanonLine2 = generateTag(addRequestPageLang, 'takanon.default.line-2');
    const defaultTakanonLine3 = generateTag(addRequestPageLang, 'takanon.default.line-3');


    if (projectId === 69) {

        takanonMessage = (
            <>
                <h4>{projectId69Title}</h4>
                <p>{projectId69Line1}</p>
                <p>{projectId69Line2}</p>
                <p>{projectId69Line3}</p>
                <p>{projectId69Line4}</p>
                <p>{projectId69Line5}</p>
            </>
        );

    } else if (projectId === 26) {

        takanonMessage = (
            <>
                <div className="fs-5 fw-medium">{projectId26Title}</div>
                <div className="p-1">
                    <div>{projectId26Line1}</div>
                    <div>{projectId26Line2}</div>
                    <div>{projectId26Line3}</div>
                </div>
            </>
        );

    } else if (projectId === 94) {

        takanonMessage = (
            <>
                <h4>{projectId94Title}</h4>
                <p>{projectId94Line1}</p>
                <p>{projectId94Line2}</p>
                <p>{projectId94Line3}</p>
                <p>{projectId94Line4}</p>
            </>
        );

    } else if (projectId === 25) {
        takanonMessage = (
            <>
                <div>{projectId25Title}</div>

                <div className="mb-2">
                    <div>{projectId25Line1}</div>
                    <div>{projectId25Line2}</div>
                    <div>{projectId25Line3}</div>
                </div>
                <div className="fw-medium">{projectId25Line4}</div>
                <div>{projectId25Line5}</div>
                <div>{projectId25Line6}</div>
                <div>{projectId25Line7}</div>
            </>
        );
    } else if (projectId === 87) {

        takanonMessage = (
            <>
                <div className="mb-2">{projectId87Line1}</div>
                <div>{projectId87Line2}</div>
                <div>{projectId87Line3}</div>
            </>
        );
    } else if (projectId === 12) {

        takanonMessage = (
            <>
                <div className="mb-2">
                    <div>{projectId12Line1}</div>
                    <div>{projectId12Line2}</div>
                    <div className="mt-1">{projectId12Line3}</div>
                </div>

                <div className="fw-medium fs-5">{projectId12Line4}</div>

                <div className="p-1 fw-medium">
                    <div>{projectId12List1}</div>
                    <div>{projectId12List2}</div>
                    <div>{projectId12List3}</div>
                    <div>{projectId12List4}</div>
                    <div>{projectId12List5}</div>
                    <div>{projectId12List6}</div>
                </div>
            </>
        );
    } else {

        takanonMessage = (
            <>
                <div>
                    {defaultTakanonLine1}
                </div>
                <div className="mb-2">
                    {defaultTakanonLine2}
                </div>
                <div>
                    {defaultTakanonLine3}
                </div>
            </>
        );
    }

    return (

        <div className='row'>
            <div className='col-12 col-lg-12 col-xxl-10'>
                <Alert
                    type={AlertColors.INFO}
                    message={(
                        <div>
                            <div className="p-2">
                                {takanonMessage}
                            </div>
                            <TakanonCheckBox />
                        </div>
                    )}
                    subject={takanonTitleTag}
                    isShow={true}
                />
            </div>
        </div>
    );
}